/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierCoverageResult } from "./CarrierCoverageResult";
import {
  CarrierCoverageResultFromJSON,
  CarrierCoverageResultFromJSONTyped,
  CarrierCoverageResultToJSON,
  CarrierCoverageResultToJSONTyped,
} from "./CarrierCoverageResult";

/**
 *
 * @export
 * @interface CustomerSpecificCarrierCoverage
 */
export interface CustomerSpecificCarrierCoverage {
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificCarrierCoverage
   */
  carrierIdentifier: string;
  /**
   *
   * @type {CarrierCoverageResult}
   * @memberof CustomerSpecificCarrierCoverage
   */
  active: CarrierCoverageResult;
  /**
   *
   * @type {CarrierCoverageResult}
   * @memberof CustomerSpecificCarrierCoverage
   */
  potential: CarrierCoverageResult;
  /**
   *
   * @type {boolean}
   * @memberof CustomerSpecificCarrierCoverage
   */
  quotingImplemented: boolean;
}

/**
 * Check if a given object implements the CustomerSpecificCarrierCoverage interface.
 */
export function instanceOfCustomerSpecificCarrierCoverage(
  value: object,
): value is CustomerSpecificCarrierCoverage {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("active" in value) || value["active"] === undefined) return false;
  if (!("potential" in value) || value["potential"] === undefined) return false;
  if (
    !("quotingImplemented" in value) ||
    value["quotingImplemented"] === undefined
  )
    return false;
  return true;
}

export function CustomerSpecificCarrierCoverageFromJSON(
  json: any,
): CustomerSpecificCarrierCoverage {
  return CustomerSpecificCarrierCoverageFromJSONTyped(json, false);
}

export function CustomerSpecificCarrierCoverageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificCarrierCoverage {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    active: CarrierCoverageResultFromJSON(json["active"]),
    potential: CarrierCoverageResultFromJSON(json["potential"]),
    quotingImplemented: json["quotingImplemented"],
  };
}

export function CustomerSpecificCarrierCoverageToJSON(
  json: any,
): CustomerSpecificCarrierCoverage {
  return CustomerSpecificCarrierCoverageToJSONTyped(json, false);
}

export function CustomerSpecificCarrierCoverageToJSONTyped(
  value?: CustomerSpecificCarrierCoverage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    active: CarrierCoverageResultToJSON(value["active"]),
    potential: CarrierCoverageResultToJSON(value["potential"]),
    quotingImplemented: value["quotingImplemented"],
  };
}
